import { lazy } from 'react';
import { isPublicSitePageEnabled } from '@/publicSite/publicSiteConfig';
import type { AppRouteDefinition } from './routes';

const DocsPage = lazy(async () => {
  const module = await import('../../pages/DocsPage');
  return { default: module.DocsPage };
});

const AppFeaturesPage = lazy(async () => {
  const module = await import('@/features/features/routes');
  return { default: module.FeaturesPage };
});

const PublicFeaturesPage = lazy(async () => {
  const module = await import('../../pages/FeaturesPage');
  return { default: module.FeaturesPage };
});

const PricingPage = lazy(async () => {
  const module = await import('../../pages/PricingPage');
  return { default: module.PricingPage };
});

const isLocalPublicSitePageEnabled = (page: 'docs' | 'features' | 'pricing'): boolean =>
  isPublicSitePageEnabled(page) || import.meta.env.DEV;

export const publicSiteRouteDefinitions: AppRouteDefinition[] = [
  {
    key: 'docs',
    path: '/docs',
    enabled: isLocalPublicSitePageEnabled('docs'),
    title: 'Docs',
    metadata: { canonicalPath: '/docs', robots: 'noindex,follow' },
    element: () => <DocsPage />,
  },
  {
    key: 'public-features',
    path: '/features',
    enabled: import.meta.env.DEV,
    title: 'Test Results Analytics Features',
    description:
      'Explore FlowQA features for test results analytics, unified test reporting, success rate trends, duration insights, suite history, and recurring failure review.',
    metadata: { canonicalPath: '/features', robots: 'noindex,follow' },
    element: ({ session }) => (session ? <AppFeaturesPage /> : <PublicFeaturesPage />),
  },
  {
    key: 'pricing',
    path: '/pricing',
    enabled: isLocalPublicSitePageEnabled('pricing'),
    title: 'Pricing',
    description:
      'View FlowQA pricing for Free, Solo, and Team plans. Compare projects, users, monthly runs, and retention.',
    metadata: { canonicalPath: '/pricing', robots: 'noindex,follow' },
    element: () => <PricingPage />,
  },
];
